// Token存储的键名
const TOKEN_KEY = 'token'
const USER_KEY = 'user'

/**
 * 设置认证Token
 * @param token JWT令牌
 */
export const setToken = (token: string): void => {
  localStorage.setItem(TOKEN_KEY, token)
}

/**
 * 获取认证Token
 * @returns 存储的Token或null
 */
export const getToken = (): string | null => {
  return localStorage.getItem(TOKEN_KEY)
}

/**
 * 移除认证Token
 */
export const removeToken = (): void => {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
}

/**
 * 检查是否已认证
 * @returns 是否已认证
 */
export const isAuthenticated = (): boolean => {
  const token = getToken()
  if (!token) return false
  try {
    const parts = token.split('.')
    if (parts.length < 2) return true
    const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')))
    if (payload && payload.exp) {
      const now = Math.floor(Date.now() / 1000)
      if (payload.exp <= now) {
        removeToken()
        return false
      }
    }
    return true
  } catch (e) {
    return true
  }
}

export const parseTokenPayload = (token?: string | null): any | null => {
  const t = token || getToken()
  if (!t) return null
  try {
    const parts = t.split('.')
    if (parts.length < 2) return null
    return JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')))
  } catch (e) {
    return null
  }
}
